import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getAllUnits } from 'modules/_common/api';

export const useAllUnitsQuery = (propertyId: string | undefined, enabled: boolean) => {
  const { data, isError, isLoading } = useQuery(
    [QUERY_KEYS.RENTALS_ALL_UNITS, propertyId],
    () => getAllUnits(propertyId),
    { enabled },
  );

  return {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    units: data?.data || data,
    isUnitsError: isError,
    isUnitsLoading: isLoading,
  };
};
